import { Fragment } from 'react';
import { CheckIcon } from './icons';
import { twMerge } from 'tailwind-merge';

export const Steps = ({
  currentStep,
  stepsAmount,
  className,
}: {
  currentStep: number;
  stepsAmount: number;
  className?: string;
}) => {
  const steps = Array.from({ length: stepsAmount }, (_, index) => index + 1);

  return (
    <div className={twMerge('w-full flex items-center justify-between px-8 py-2', className)}>
      {steps.map((step) => {
        const isActive = step === currentStep;
        const isCompleted = step < currentStep;

        return (
          <Fragment key={step}>
            <div className="flex flex-col items-center relative">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-colors ${
                  isActive || isCompleted ? 'bg-primary text-neutral-black' : 'bg-neutral-800 text-neutral-100'
                }`}
              >
                {isCompleted ? <CheckIcon height={16} width={16} className="text-neutral-black" /> : step}
              </div>
            </div>
            {step < steps.length && (
              <div className={`flex-1 h-0.5 mx-1 transition-colors ${isCompleted ? 'bg-primary' : 'bg-neutral-800'}`} />
            )}
          </Fragment>
        );
      })}
    </div>
  );
};
